<template>
    <div>
        <a-form-item :label="$t('Standart Modül')">
            <a-select v-model="localValue.module">
                <a-select-option value="contact">{{ $t('Kişi') }}</a-select-option>
                <a-select-option value="ticket">{{ $t('Ticket') }}</a-select-option>
                <a-select-option value="task">{{ $t('Görev') }}</a-select-option>
                <a-select-option value="calendar">{{ $t('Etkinlik/Rezervasyon') }}</a-select-option>
                <a-select-option value="email">{{ $t('E-posta') }}</a-select-option>
            </a-select>
        </a-form-item>

        <a-form-item :label="$t('Bağlantı Türü')">
            <a-select v-model="localValue.connectionType" @change="handleConnectionTypeChange">
                <a-select-option value="field">{{ $t('Alan') }}</a-select-option>
                <a-select-option 
                    v-if="localValue.module === 'contact'" 
                    value="customProperties"
                >
                    {{ $t('Özel Alanlar') }}
                </a-select-option>
            </a-select>
        </a-form-item>

        <a-form-item v-if="localValue.connectionType === 'field'" :label="$t('Alan')">
            <a-select v-model="localValue.field">
                <a-select-option value="_id">ID</a-select-option>
                <template v-if="localValue.module === 'contact'">
                    <a-select-option value="name">{{ $t('İsim') }}</a-select-option>
                    <a-select-option value="email">{{ $t('E-posta') }}</a-select-option>
                    <a-select-option value="phone">{{ $t('Telefon') }}</a-select-option>
                    <a-select-option value="whatsappNumber">{{ $t('WhatsApp Numarası') }}</a-select-option>
                </template>
            </a-select>
        </a-form-item>

        <a-form-item 
            v-if="localValue.connectionType === 'customProperties'" 
            :label="$t('Özel Alan')"
        >
            <a-select v-model="localValue.field">
                <a-select-option 
                    v-for="prop in contactProperties" 
                    :key="prop._id" 
                    :value="prop._id"
                >
                    {{ prop.label }}
                </a-select-option>
            </a-select>
        </a-form-item>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: true
        },
        contactProperties: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            localValue: this.value
        }
    },
    methods: {
        handleConnectionTypeChange() {
            this.localValue.field = null;
            this.$emit('input', this.localValue);
        }
    },
    watch: {
        value: {
            deep: true,
            handler(newVal) {
                this.localValue = newVal;
            }
        },
        localValue: {
            deep: true,
            handler(newVal) {
                this.$emit('input', newVal);
            }
        }
    }
}
</script> 